// extracted by mini-css-extract-plugin
module.exports = {"button":"SearchAgainButton_button__gU0W6","show":"SearchAgainButton_show__L3B5y","icon":"SearchAgainButton_icon__9ja9_","text":"SearchAgainButton_text__NTrQn"};